import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Jul 16 2019
 * @author Tomáš Leity
 */
import * as React from 'react';
import AccordionSectionStyled from './styled/AccordionSectionStyled';
import translate from '../../i18n/translate';
import Icon, { IconColor, IconType } from '../../media/Icon';

var AccordionSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AccordionSection, _React$Component);

  function AccordionSection() {
    _classCallCheck(this, AccordionSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(AccordionSection).apply(this, arguments));
  }

  _createClass(AccordionSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          label = _this$props.label,
          onClick = _this$props.onClick,
          isOpen = _this$props.isOpen,
          labelIcon = _this$props.labelIcon,
          labelIconColor = _this$props.labelIconColor;
      return React.createElement(AccordionSectionStyled, {
        className: "accordion-section".concat(className ? " ".concat(className) : '').concat(isOpen ? ' isOpened' : '')
      }, React.createElement("div", {
        className: "accordion-header",
        onClick: onClick
      }, labelIcon ? React.createElement("span", {
        className: "accordion-header--icon"
      }, React.createElement(Icon, {
        iconType: labelIcon,
        iconColor: labelIconColor || IconColor.Text,
        iconHeight: 18
      })) : null, React.createElement("h4", {
        className: "accordion-header--label"
      }, translate(label)), React.createElement("span", {
        className: "accordion-header--iconArrow"
      }, React.createElement(Icon, {
        iconType: isOpen ? IconType.chevronUp : IconType.chevronDown,
        iconColor: IconColor.Text,
        iconHeight: 20
      }))), React.createElement("div", {
        className: "accordion-inner"
      }, isOpen === true ? children : null));
    }
  }]);

  return AccordionSection;
}(React.Component);

;
export default AccordionSection;